import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';
import logo from '../assets/braineka-logo.png'; // Asegúrate de tener el logo en src/assets/

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-container">
      <div className="landing-box">
        <img src={logo} alt="Braineka" className="landing-logo" />
        <h1 className="landing-title">Bienvenido a Braineka</h1>
        <div className="landing-buttons">
          <button className="landing-btn" onClick={() => navigate('/registro-neuroterapeuta')}>
            Registro Neuroterapeuta
          </button>
          <button className="landing-btn" onClick={() => navigate('/login')}>
            Acceso
          </button>
        </div>
        <button className="landing-link" onClick={() => navigate('/recuperar-password')}>
          ¿Olvidaste tu contraseña?
        </button>
      </div>
    </div>
  );
}
